export default __webpack_public_path__ + "static/media/rpgo.4815e310.svg";